module.exports = __webpack_public_path__ + "static/query-alerter-e25358ca761a77cb3b17efa03715f2c4.png";